import { Alert, Button, Card, Snackbar } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { Form, InputGroup, Table } from "react-bootstrap";
import LoadingIcon from "../components/LoadingIcon";

const Referral = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [notificationType, setNotificationType] = useState("");
  const [showNotification, setShowNotification] = useState("");
  const [user, setUser] = useState({});
  const [totalUsers, setTotalUsers] = useState(0);
  const [activeUsers, setActiveUsers] = useState(0);
  const [commission, setCommission] = useState(0.0);
  const token = localStorage.getItem("token");
  const vertical = "top";
  const horizontal = "center";

  const getDetails = useCallback(async () => {
    setLoading(true);
    const response = await fetch(`${process.env.REACT_APP_API_URL}referral`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });

    const data = await response.json();

    setUser(data.User.referral_code);
    setTotalUsers(data.totalUsers);
    setActiveUsers(data.activeUser);
    setCommission(data.commission);

    setLoading(false);
  }, [token]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  return (
    <div className="min-h-screen">
      <div className="mb-2 mt-3">
        <h3 className="font-bold text-white">Referral</h3>
      </div>
      {loading ? (
        <div className="h-screen flex items-center justify-center">
          <LoadingIcon />
        </div>
      ) : (
        <>
          <Snackbar
            open={showNotification}
            autoHideDuration={6000}
            anchorOrigin={{ vertical, horizontal }}
          >
            <Alert
              message={message}
              severity={notificationType}
              className="!text-base"
            >
              {message}
            </Alert>
          </Snackbar>
          <Card className="p-2 mb-8 !bg-[#1B4242]">
            <div className="lg:w-1/2">
              <InputGroup className="mb-3 mt-4">
                <Form.Control
                  type="text"
                  placeholder="Disabled input"
                  aria-label="Disabled input example"
                  disabled
                  value={`https://app.coinsmentorship.com/client-register?${user}`}
                  readOnly
                />
                <Button
                  variant="contained"
                  id="button-addon2"
                  className="!bg-[#101010]"
                  onClick={() => {
                    setShowNotification(true);
                    navigator.clipboard.writeText(
                      `https://app.coinsmentorship.com/client-register?${user}`
                    );
                    setNotificationType("success");
                    setMessage("Referral code Copied!");
                    setTimeout(() => setShowNotification(false), 4000);
                  }}
                >
                  Copy
                </Button>
              </InputGroup>
            </div>
          </Card>
          <Card className="p-2 !bg-[#1B4242]">
            <div className="mb-4 mt-3">
              <h3 className="text-lg font-bold text-white">Your Referrals</h3>
            </div>
            <Table hover size="md">
              <tbody>
                <tr className="border-b border-black">
                  <td className="!bg-[#1B4242] text-white">Referrals:</td>
                  <td className="!bg-[#1B4242] text-white">{totalUsers}</td>
                </tr>
                <tr className="border-b border-black">
                  <td className="!bg-[#1B4242] text-white">
                    Active Referrals:
                  </td>
                  <td className="!bg-[#1B4242] text-white">{activeUsers}</td>
                </tr>
                <tr className="border-b border-black">
                  <td className="!bg-[#1B4242] text-white">
                    Total Commission:
                  </td>
                  <td className="!text-green-500 !bg-[#1B4242]">
                    {" "}
                    ${commission}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Card>
        </>
      )}
    </div>
  );
};

export default Referral;
